import { UploadFile } from "../UploadBox/types";
import { getFullTime } from "../../controllers/JoyspaceController";
import api from "../../api";
import events from "../../context/events";
import { message } from "antd";
import { analysisLog } from "@/utils/logAnalytics";
import { useNavigator } from "@/utils/NetworkCheck";
import { RcFile } from "antd/lib/upload";
import { folderType } from "../../config/permissions.config";
import { ActionType } from "../../types";

// export const createFolder = async (
//   parentFolderId: string,
//   name: string,
//   folderId?: string
// ): Promise<string | null> => {
//   const data = await api.categories.create(parentFolderId || "", name);
//   if (data) {
//     let res = { ...data };
//     res.updated_at = getFullTime(res.updated_at);
//     res.created_at = getFullTime(res.created_at);
//     res.openTime = getFullTime(res.openTime);
//     if (parentFolderId === folderId) {
//       events.emit("list.reload", { folderId, type: ActionType.Folder });
//     }
//     return res.id;
//   }
//   return null;
// };
export const createFolderBatch = async (
  parentFolderId: string,
  pathNames: string[]
): Promise<any[] | null> => {
  const data = await api.categories.batchCreate(parentFolderId || "", pathNames);
  if (data?.data) {
    events.emit("list.reload", { parentFolderId, type: ActionType.Folder });
    return data.data;
  } else {
    message.error(data?.status || "操作失败");
    return null;
  }
};
// eslint-disable-next-line complexity
export const handleUploadFolder = async (selectFiles: any[], options: any) => {
  console.log("handleUploadFoldershan1111", selectFiles);
  if (selectFiles.length === 0) {
    message.warning("不支持上传空文件夹");
    return;
  }
  const files: UploadFile[] = [];
  const folders: any = {};
  const { folderId, uploadControlInstance, gid, appRuntimeEnv, spaceId } = options;
  const pathNames: string[] = [];
  for (let file of selectFiles) {
    const path = file?.usePath || file?.webkitRelativePath || "";
    console.log(file, "fileshan1111", path);
    if (!file.type && file.name === ".DS_Store") continue;
    const relativePaths = path.split("/") || [];
    if (relativePaths.length > 1) {
      relativePaths?.pop();
      let parentPath = "";
      for (const name of relativePaths) {
        const path = parentPath.length ? `${parentPath}/${name}` : name;
        if (!pathNames.includes(path)) {
          pathNames.push(path);
        }
        parentPath = path;
      }
      Object.assign(file, {
        folderId: parentPath
      });
    }
  }
  const folderInfos = await createFolderBatch(folderId || folderType.MY, pathNames);
  if (!folderInfos) return;
  for (let folderInfo of folderInfos) {
    folders[folderInfo?.pathName] = folderInfo.id;
  }
  for (let file of selectFiles) {
    if (!file.type && file.name === ".DS_Store") continue;
    if (file.folderId in folders) {
      Object.assign(file, {
        folderId: folders[file.folderId],
        spaceId
      });
      files.push(file as UploadFile);
    }
  }
  if (files.length <= 0) return;
  try {
    const { fileService, joyspaceWpsTarget } = appRuntimeEnv;
    uploadControlInstance?.addFiles(files, fileService, { joyspaceWpsTarget }, spaceId);
  } catch (e) {
    console.log(444, e);
  }
};
const getFileFromEntryRecursively = (entry: any, fileList: any) => {
  return new Promise((resolve, reject) => {
    if (entry.isFile) {
      entry.file(
        (file: any) => {
          // 这里的 file.webkitRelativePath 都是 "" ,不是我们想要的.
          // entry.fullPath 是前面带斜杠的,要把斜杠去掉的
          let path = entry.fullPath.substring(1);
          console.log(file, "isFileshan111");
          Object.assign(file, { usePath: path });
          fileList.push(file);
          resolve(1);
        },
        (e: any) => {
          console.log(e);
          reject(e);
        }
      );
    } else {
      let reader = entry.createReader();
      reader.readEntries(
        async (entries: any) => {
          for (let entry of entries) {
            await getFileFromEntryRecursively(entry, fileList);
          }
          resolve(1);
        },
        (e: any) => {
          reject(e);
        }
      );
    }
  });
};
// 拖拽上传
const beforeUpload = async (
  _file: RcFile,
  { folderId, spaceId, appRuntimeEnv, uploadControlInstance, from }: any
) => {
  const file = _file as UploadFile;
  const { type, size, state } = file as any;
  if (!size) {
    message.warning("不能上传大小为0的文件");
    return;
  }
  // isTips = true;
  Object.assign(file, { folderId, spaceId, categoryId: "", projectId: "" });
  const { fileService, joyspaceWpsTarget } = appRuntimeEnv;
  if (!uploadControlInstance) {
    console.log("joyspaceuploadControlInstance获取出错");
    return;
  }
  try {
    analysisLog(
      "xtbg_jzb_joyspace_home_1676548210761",
      "41",
      from,
      file.name,
      spaceId,
      file.type,
      "drag"
    );
    await uploadControlInstance.addFile(file, fileService, { joyspaceWpsTarget }, spaceId);
  } catch (e) {
    console.error(e);
  }
};

// beforeUpload 接收的fileList是当前用户选择的文件
const handleUploadFile = (falseList: any[] = [], ope: any) => {
  for (let item of falseList) {
    beforeUpload(item, ope);
  }
};
const handleUploadDrop = async (e: any, ope: any) => {
  if (!useNavigator.onLine) {
    return;
  }
  const df = e.dataTransfer;
  if (!e.dataTransfer.types || !e.dataTransfer.types.includes("Files")) {
    return;
  }
  // 以下过滤条件为文件往外拖
  if (e.dataTransfer.effectAllowed === "copyLink") {
    return;
  }
  console.log("files=================>", df.items[0].type, df.files[0].type);
  if (ope.folderId === folderType.SHARE) {
    for (let i = 0; i <= df.items.length - 1; i++) {
      let item = df.items[i];
      console.log("files=================>1", item.type);
      if (item.kind === "file" && item?.webkitGetAsEntry()?.isFile) {
        message.warn("共享文件列表不支持上传文件");
        return;
      }
    }
  }
  let folderCount = 0;
  df.items.forEach(async (item: any) => {
    // console.log("files=================>1", item.type);
    if (item.kind === "file") {
      let entry = item.webkitGetAsEntry();
      if (entry.isFile) {
        // console.log("files=================>2", item.type, item.getAsFile());
        handleUploadFile([item.getAsFile()], ope);
        // entry.file(
        //   (file: any) => {
        //     console.log(file.type, "test11");
        //     // handleUploadFile([file], ope);
        //   },
        //   (e: any) => {
        //     console.log(e);
        //   }
        // );
      } else {
        const files: any[] = [];
        folderCount++;
        await getFileFromEntryRecursively(entry, files);
        handleUploadFolder(files, ope);
      }
    }
  });
  if (folderCount) {
    analysisLog("xtbg_jzb_joyspace_home_1676548210761", "46", "drag", ope?.from);
  }
};
const handleUploadDragOver = (e: any) => {
  e.preventDefault();
  e.stopPropagation();
  // e?.persist();

  const { localName = "", className = "" } = e.target || {};
  if (
    !localName ||
    localName === "svg" ||
    localName === "span" ||
    localName === "button" ||
    localName === "use" ||
    localName === "ul" ||
    localName === "li" ||
    className === "batch-button-space"
  ) {
    return false;
  }
  // console.log(e);
  if (!e.dataTransfer.types || !e.dataTransfer.types.includes("Files")) {
    return false;
  }
  // 以下过滤条件为文件往外拖
  if (e.dataTransfer.effectAllowed === "copyLink") {
    return false;
  }
  return true;
};
const handleUploadDrag = (e: any, ope: any) => {
  const { callback } = ope;
  e.preventDefault();
  e.stopPropagation();
  // e?.persist();
  if (e.type === "dragleave") {
    callback?.(false);
  } else if (e.type === "dragover") {
    callback(handleUploadDragOver(e));
  } else if (e.type === "drop") {
    callback?.(false);
    handleUploadDrop?.(e, ope);
    events.emit("hideContextMenus"); // 关闭右键菜单events.emit("hideContextMenus"); // 关闭右键菜单
    events.emit("handlePopoverVisibleChange"); // 关闭更多菜单events.emit("handlePopoverVisibleChange");
  }
};

export { handleUploadDrag };
